"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Trybe
 * This site provides documentation on how to use the Trybe Shop API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
* @export
* @enum {string}
*/
var EscPosConnectorProvisionStatusEnum;
(function (EscPosConnectorProvisionStatusEnum) {
    EscPosConnectorProvisionStatusEnum["Ready"] = "ready";
    EscPosConnectorProvisionStatusEnum["Provisioning"] = "provisioning";
    EscPosConnectorProvisionStatusEnum["Queued"] = "queued";
    EscPosConnectorProvisionStatusEnum["Error"] = "error";
    EscPosConnectorProvisionStatusEnum["Deleting"] = "deleting";
})(EscPosConnectorProvisionStatusEnum = exports.EscPosConnectorProvisionStatusEnum || (exports.EscPosConnectorProvisionStatusEnum = {})); /**
* @export
* @enum {string}
*/
var EscPosConnectorPaperSizeEnum;
(function (EscPosConnectorPaperSizeEnum) {
    EscPosConnectorPaperSizeEnum["_80mm"] = "80mm";
    EscPosConnectorPaperSizeEnum["_58mm"] = "58mm";
})(EscPosConnectorPaperSizeEnum = exports.EscPosConnectorPaperSizeEnum || (exports.EscPosConnectorPaperSizeEnum = {}));
function EscPosConnectorFromJSON(json) {
    return EscPosConnectorFromJSONTyped(json, false);
}
exports.EscPosConnectorFromJSON = EscPosConnectorFromJSON;
function EscPosConnectorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'provision_status': json['provision_status'],
        'paper_size': json['paper_size'],
        'site_id': json['site_id'],
        'created_at': (new Date(json['created_at'])),
        'updated_at': (new Date(json['updated_at'])),
    };
}
exports.EscPosConnectorFromJSONTyped = EscPosConnectorFromJSONTyped;
function EscPosConnectorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'provision_status': value.provision_status,
        'paper_size': value.paper_size,
        'site_id': value.site_id,
        'created_at': (value.created_at.toISOString()),
        'updated_at': (value.updated_at.toISOString()),
    };
}
exports.EscPosConnectorToJSON = EscPosConnectorToJSON;
